import Tab from "@mui/material/Tab";

export default Tab;
